import { inventoryVendorService } from "../../../../../Api/Services/InventoryService/inventoryVendor";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../../constants/error";
import createGenericSlice from "../../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../../utils/reduxUtils/createServiceAsyncThunk";
import { InventoryVendorListResponse, GetVendorsParams } from "../../types";

// Fetch vendors
export const fetchInventoryVendors = createServiceAsyncThunk<
    InventoryVendorListResponse,
    GetVendorsParams // params type
>(
    ACTION_NAMES.FETCH_INVENTORY_VENDOR_LIST, 
    (params) => inventoryVendorService.getVendors(params),
    ERROR_MESSAGES.FETCH_INVENTORY_VENDOR_FAILURE 
);

export const inventoryVendorSlice = createGenericSlice<
    InventoryVendorListResponse,
    GetVendorsParams
>(
    SLICE_NAMES.INVENTORY_VENDOR_LIST_SLICE, 
    fetchInventoryVendors
);

export const {
    clearError: clearInventoryVendorListError,
    clearSuccessMessage: clearInventoryVendorListSuccessMessage,
} = inventoryVendorSlice.actions;

export default inventoryVendorSlice.reducer;